import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostDropBoxDelete extends BaseAdapter<null> implements AdapterInterface {
  rawResponse: null;

  async adaptResponse(request: { s3Key: string }): Promise<void> {
    await this.fetchApiResponse('/api/drop-box/delete', HTTPMethod.Post, {
      s3_key: request.s3Key,
    });
  }
}
